function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ((useActualHostSelector ? ":host {" : hostSelector + " {")) + "--left-off-listing-padding-top: var(--ads-padding-top);}wds-tiles-grid" + shadowSelector + " {padding-top: var(--left-off-listing-padding-top);display: block;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet];